// extracted by mini-css-extract-plugin
export var sponsorAds = "sponsorAdsBanner-module--sponsorAds--hUbGj";
export var sponsorAds__adMark = "sponsorAdsBanner-module--sponsorAds__adMark--dtCKe";
export var sponsorAds__desktop = "sponsorAdsBanner-module--sponsorAds__desktop--weu2O";
export var sponsorAds__mobile = "sponsorAdsBanner-module--sponsorAds__mobile--+o2e7";